export const listDcaFrequency = [
  { content: 'dca.every_day', value: 'Daily' },
  { content: 'dca.every_2_days', value: 'Every2Days' },
  { content: 'dca.every_3_days', value: 'Every3Days' },
  { content: 'dca.every_7_days', value: 'Every7Days' },
]

